var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('a',{class:{ 'is-loading': _vm.isProcessing },on:{"click":function($event){$event.preventDefault();return _vm.tryDownload($event)}}},[_vm._t("default",[_c('b-icon',{attrs:{"icon":"arrow-down","size":"is-small"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("_action.download_object", {
        object: _vm.$t("_.invoice").toLowerCase()
      })))])])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }